import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';


import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Grid from 'material-ui/Grid';

import axios from 'axios';
import moment from 'moment-timezone';
import tsl from './../../../tsl';
import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Typography from "material-ui/Typography/Typography";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl, InputAdornment,
  InputLabel,
  MenuItem
} from "material-ui";
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui-icons/Edit';
import AddIcon from 'material-ui-icons/Add';
import DeleteIcon from 'material-ui-icons/Delete';
import ClearIcon from 'material-ui-icons/Clear';
import Dialog from "material-ui/Dialog/Dialog";
import TextField from "components/forms/ValidatedTextField";
import validations from 'components/forms/validations';
import withValidatedInputs from 'components/forms/withValidatedInputs';

import { getSettings } from "utils/client";
import {ValidatedDatePicker as DatePicker} from "components/forms/ValidatedPickers";
import config from "../../../../config";
import Select from 'components/forms/ValidatedSelect';

const styles = {
  endAdornment: {
    position: 'absolute',
    bottom: 0,
    right: 0
  }
};

class PromoCodesList extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			rowsPerPage: 50,
		  page: 0,
		  total: 0,
			data: [],
      filter_expanded: true,
      groups: null,
      filter: {
			  group: 0
      },
      new_group: ''
		};
	}

	componentDidMount() {
		this.loadGroups(true).then(() => this.loadEntities(1));
	}

	loadGroups(first = false) {
	  return axios.get('/api/operator/codes/group')
			.then((response) => {
				//console.log(response.data);
				this.setState(state => ({
					groups: response.data,
          filter: {
					  group: first && response.data.length > 0 ? response.data[0].id : state.filter.group
          }
				}));
			});
  }

  getFilterQuery = () => {

	  const {
	    filter
    } = this.state;

	  let filterQuery = `group=${filter.group}`;

	  if (filter.from) {
	    filterQuery += '&from=' + filter.from.format("YYYY-MM-DD");
    }
    if (filter.to) {
	    filterQuery += '&to=' + filter.to.format("YYYY-MM-DD");
    }

    return filterQuery;
  };

	loadEntities(page) {

    const filterQuery = this.getFilterQuery();

		axios.get(`/api/operator/codes?page=${page}&perPage=${this.state.rowsPerPage}&${filterQuery}` )
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage = (e, page) => {
		this.loadEntities(page+1);	// paginator counts pages as indexes (starting 0)
	};

	handleFilterChange = (name) => (e) => {
	  let target;

	  if (e._isAMomentObject) {
	    target = {
	      value: e
      }
    } else {
      target = e.target;
    }

	  this.setState(state => ({
      filter: {
        ...state.filter,
        [name]: target.value
      }
    }), () => this.loadEntities(1));
  };

	handleInputChange = (name) => (e) => {
	  const target = e.target;

	  this.setState(state => ({
      [name]: target.value
    }));
  };

	handleNewCodeInputChange = (name) => (e) => {
	  let target;

	  if (e._isAMomentObject) {
	    target = {
	      value: e
      }
    } else {
      target = e.target;
    }

	  this.setState(state => ({
      newCode: {
        ...state.newCode,
        [name]: target.value
      }
    }));
  };

	handleClearNewCodeInput = (name) => (e) => {
	  e.stopPropagation();

	  this.setState(state => ({
      newCode: {
        ...state.newCode,
        [name]: null
      }
    }));
  };

	handleClearFilterInput = (name) => (e) => {
	  e.stopPropagation();

	  this.setState(state => ({
      filter: {
        ...state.filter,
        [name]: null
      }
    }), () => this.loadEntities(1));
  };

	handleManageGroups = () => {
	  this.setState({
      manageGroups: true
    });
  };

	handleCloseGroupsDialog = () => {
	  this.setState({
      manageGroups: false,
      new_group: ''
    });
  };

	handleAddGroup = (e) => {
	  e.stopPropagation();
	  e.preventDefault();

	  axios.post('/api/operator/codes/group/add', {
	    name: this.state.new_group
    }).then((res) => {
      this.setState(state => ({
        new_group: '',
        groups: [
          ...state.groups,
          res.data
        ]
      }));
    });

	  return false; // prevent form submission
  };

	handleDeleteGroup = (group) => (e) => {
	  axios.post(`/api/operator/codes/group/${group.id}/delete`, {
	    name: this.state.new_group
    }).then((res) => {
      this.setState(state => ({
        groups: res.data
      }));
    });
  };

	handleDeleteCode = (code) => (e) => {
	  this.setState({
      deleteCode: code
    });
  };

	handleDeleteCodeConfirm = () => {
	  return axios.post(`/api/operator/codes/${this.state.deleteCode.id}/delete`).then((res) => {
	    this.setState({
        deleteCode: null
      });

      this.loadEntities(this.state.page);
      this.loadGroups();
    });
  };

	handleDeleteCodeCancel  = () => {
	  this.setState({
      deleteCode: null
    });
  };

	handleCloseAddCodeDialog = () => {
	  this.setState({
      newCode: null
    })
  };

	handleOpenAddCodeDialog = () => {
	  this.setState({
      newCode: {
        group: this.state.filter.group,
        type: 'percent',
        value: '0'
      }
    })
  };

	handleAddCode = () => {
	  const {
	    newCode
    } = this.state;

	  if (this.props.trySubmit()) {
      return axios.post('/api/operator/codes', {
        ...newCode,
        valid_until: newCode.valid_until ? newCode.valid_until.format("YYYY-MM-DD 23:59:59") : null,
        valid_from: newCode.valid_from ? newCode.valid_from.format("YYYY-MM-DD 00:00:00") : null,
      }).then(() => {
        this.setState({
          newCode: null
        });

        this.loadGroups();
        this.loadEntities(this.state.page);
      });
    }
  };

	handleOpenEditCodeDialog = (code) => () => {
    this.setState({
      newCode: {
        ...code,
        group: code.group.id,
        type: code.discount_percent !== null ? 'percent' : 'abs',
        value: code.discount_percent !== null ? code.discount_percent : code.discount_abs,
        valid_from: code.valid_from ? moment(code.valid_from) : null,
        valid_until: code.valid_until ? moment(code.valid_until) : null,
      }
    })
  };

	toggleFilter = () => {
	  this.setState(state => ({
      filter_expanded: !state.filter_expanded
    }));
  };

	renderDeleteCodeConfirmation = () => {
	  const {
	    deleteCode
    } = this.state;

	  if (deleteCode) {
	    return (
            <Dialog onClose={this.handleDeleteCodeCancel} open={true} >
                <DialogTitle>{tsl('promo.delete_code', deleteCode)}</DialogTitle>
              <DialogContent>
                {tsl('promo.delete_code.text', deleteCode)}
              </DialogContent>
              <DialogActions>
                  <Button onClick={this.handleDeleteCodeConfirm}>
                    {tsl('promo.delete_code.confirm')}
                  </Button>
                  <Button onClick={this.handleDeleteCodeCancel} color="primary">
                    {tsl('promo.delete_code.cancel')}
                  </Button>
                </DialogActions>
            </Dialog>
      );
    }

    return null;
  };

	handleGenerateCode = () => {
    const randomStr = Math.random().toString(36).substring(2, 15);

    this.setState(state => ({
      newCode: {
        ...state.newCode,
        code: randomStr
      }
    }));
  };

	renderAddCodeDialog = () => {
	  const {
	    newCode
    } = this.state;

	  const client = getSettings('client');

	  // use the same scheme as the API uses
	  const schema = config.API_ROOT.indexOf('https') === 0 ? 'https' : 'http';

	  if (newCode) {
	    return (
            <Dialog onClose={this.handleCloseAddCodeDialog} open={true} >
                <DialogTitle>{tsl('promo.add_code')}</DialogTitle>
              <DialogContent>
                <Grid container spacing={8}>
                  <Grid item xs={10}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="group">{tsl('promo.filter.group')}</InputLabel>

                      <Select
                        required
                        name="group"
                        value={newCode.group || []}
                        onChange={this.handleNewCodeInputChange('group')}
                      >
                        {this.state.groups.map((g) => {
                            return (<MenuItem key={g.id} value={g.id}>{g.name}</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <IconButton
                      onClick={this.handleManageGroups}
                    >
                      <EditIcon />
                    </IconButton>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      formActions={this.props.formActions}
                      required
                      fullWidth
                      label={tsl('promo.add_code.code')}
                      name="newCode.code"
                      onChange={this.handleNewCodeInputChange('code')}
                      value={newCode.code || ''}
                      InputProps={{
                        endAdornment: <InputAdornment position="end"><Button onClick={this.handleGenerateCode} color="primary">{tsl('promo.add_code.generate')}</Button></InputAdornment>
                      }}
                      helperText={newCode.code &&
                        <div>
                          {tsl('promo.add_code.url')}: <a target="_blank" href={`${schema}://${client.domain}/${newCode.code}`}>{`${schema}://${client.domain}/${newCode.code}`}</a>
                        </div>
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      formActions={this.props.formActions}
                      fullWidth
                      label={tsl('promo.add_code.name')}
                      name="newCode.name"
                      onChange={this.handleNewCodeInputChange('name')}
                      value={newCode.name || ''}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="discount_type">{tsl('promo.add_code.discount_type')}</InputLabel>

                      <Select
                        name="discount_type"
                        value={newCode.type || []}
                        onChange={this.handleNewCodeInputChange('type')}
                      >
                        <MenuItem value="percent">{tsl('promo.add_code.discount_type.percent')}</MenuItem>
                        <MenuItem value="abs">{tsl('promo.add_code.discount_type.abs')}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      formActions={this.props.formActions}
                      required
                      fullWidth
                      label={tsl('promo.add_code.discount_value')}
                      name="newCode.value"
                      onChange={this.handleNewCodeInputChange('value')}
                      value={newCode.value || ''}
                      InputProps={{endAdornment:
                                <InputAdornment position="end">{newCode.type === 'abs' ? getSettings('currency').symbol : '%'}</InputAdornment>}}
                      validations={[
                        validations.isNumeric
                      ]}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <DatePicker
                        formActions={this.props.formActions}
                        fullWidth
	                			label={tsl('promo.add_code.valid_from')}
	                			format="LL"
				                value={newCode.valid_from || ''}
				                onChange={this.handleNewCodeInputChange('valid_from')}
				                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
				                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
				                invalidLabel=""
                        InputProps={{
                            endAdornment: (
                                <IconButton style={styles.endAdornment}  onClick={this.handleClearNewCodeInput('valid_from')}>
                                    <ClearIcon />
                                </IconButton>
                            ),
                        }}
                        validations={[
                          validations.createIsNotLaterThan({
                            label: tsl('promo.add_code.valid_until'),
                            value: newCode.valid_until
                          })
                        ]}
	                		 />
                  </Grid>


                  <Grid item xs={6}>
                    <DatePicker
                        formActions={this.props.formActions}
                        fullWidth
	                			label={tsl('promo.add_code.valid_until')}
	                			format="LL"
				                value={newCode.valid_until || ''}
				                onChange={this.handleNewCodeInputChange('valid_until')}
				                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
				                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
				                invalidLabel=""
                        InputProps={{
                            endAdornment: (
                                <IconButton style={styles.endAdornment}  onClick={this.handleClearNewCodeInput('valid_until')}>
                                    <ClearIcon />
                                </IconButton>
                            ),
                        }}
                        validations={[
                          validations.createIsNotSoonerThan({
                            label: tsl('promo.add_code.valid_from'),
                            value: newCode.valid_from
                          })
                        ]}
	                		 />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                  <Button onClick={this.handleCloseAddCodeDialog}>
                    {tsl('promo.add_code.cancel')}
                  </Button>

                  <Button onClick={this.handleAddCode} color="primary">
                    {tsl('promo.add_code.confirm')}
                  </Button>
                </DialogActions>
            </Dialog>
      );
    }

    return null;
  };

	renderGroupsDialog = () => {
      const {
        groups
      } = this.state;

      if (groups !== null && this.state.manageGroups) {
          return (
            <Dialog onClose={this.handleCloseGroupsDialog} open={true} >
                <DialogTitle>{tsl('promo.manage_groups')}</DialogTitle>
                <DialogContent>
                  {groups.map(g => (
                    <ListItem key={g.id}>
                      <ListItemText primary={`${g.name} (${g.codes_count})`}/>
                      <ListItemSecondaryAction>
                        {
                          g.codes_count == 0 &&
                          <IconButton onClick={this.handleDeleteGroup(g)}>
                            <DeleteIcon />
                          </IconButton>
                        }
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}

                  <ListItem>
                      <form onSubmit={this.handleAddGroup} action="#">
                        <TextField
                          label={tsl('promo.manage_groups.add_new')}
                          name="new_group"
                          onChange={this.handleInputChange('new_group')}
                          value={this.state.new_group || ''}
                        />
                      </form>
                      <ListItemSecondaryAction>
                        <IconButton onClick={this.handleAddGroup}>
                          <AddIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                  </ListItem>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseGroupsDialog} color="primary">
                    {tsl('promo.manage_groups.close')}
                  </Button>
                </DialogActions>
            </Dialog>
          );
      } else {
          return null;
      }
    };

	getExportURL = () => {
    const filterQuery = this.getFilterQuery();
    const token = axios.defaults.headers.common['Authorization'].replace('Bearer ', '');

	  return `${config.API_ROOT}export/codes/csv?_token=${token}&${filterQuery}`;
  };

  render() {

    const {
      groups,
      filter
    } = this.state;

    if (groups === null) {
      return null;
    }

    return (
      <div>
        <ExpansionPanel expanded={this.state.filter_expanded} onChange={this.toggleFilter}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
              <Typography>{tsl('promo.filter.header')}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Grid container>
                  <Grid item xs={9}>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="group">{tsl('promo.filter.group')}</InputLabel>

                      <Select
                        name="group"
                        value={filter.group || []}
                        onChange={this.handleFilterChange('group')}
                      >
                        {groups.map((g) => {
                            return (<MenuItem key={g.id} value={g.id}>{g.name} ({g.codes_count})</MenuItem>);
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <IconButton
                      onClick={this.handleManageGroups}
                    >
                      <EditIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <Grid container>
                  <Grid item xs={6}>
                    <DatePicker
                      fullWidth
                      label={tsl('promo.filter.from')}
                      format="LL"
                      value={filter.from || ''}
                      onChange={this.handleFilterChange('from')}
                      leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                      rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                      invalidLabel=""
                      InputProps={{
                          endAdornment: (
                              <IconButton style={styles.endAdornment} onClick={this.handleClearFilterInput('from')}>
                                  <ClearIcon />
                              </IconButton>
                          ),
                      }}
                     />
                  </Grid>

                  <Grid item xs={6}>
                    <DatePicker
                      fullWidth
                      label={tsl('promo.filter.to')}
                      format="LL"
                      value={filter.to || ''}
                      onChange={this.handleFilterChange('to')}
                      leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                      rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                      invalidLabel=""
                      InputProps={{
                          endAdornment: (
                              <IconButton style={styles.endAdornment}  onClick={this.handleClearFilterInput('to')}>
                                  <ClearIcon />
                              </IconButton>
                          ),
                      }}
                     />
                  </Grid>

                  <Grid item xs={6}>
                    <Button raised color="primary" href={this.getExportURL()}>{tsl('promo.btn.export_csv')}</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

          </ExpansionPanelDetails>
        </ExpansionPanel>

        <Paper>
            <div className="flex-auto">
                <div className="table-responsive-material">
                    <List>
                        {this.state.data.map((model, index) => {
                            return (<div key={model.id}>
                                <ListItem button onClick={this.handleOpenEditCodeDialog(model)}>
                                    <Grid container spacing={0}>
                                        <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                          primary={<span className={(model.expired ? ' text-strikethrough' : '')}>{model.code}{model.name ? <span className="text-muted"> - {model.name}</span> : ''}</span>}
                                                secondary={
                                                  <span><i className="zmdi zmdi-folder" />{' '}{model.group ? model.group.name : 'N/A'}</span>
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                primary={<span><i className="zmdi zmdi-balance-wallet" />{' '}{model.discount_abs === null ? model.discount_percent + ' %' : model.discount_abs + ' ' + model.currency.code}</span>}
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                primary={<span><i className="zmdi zmdi-alarm" />{' '}{model.max_uses === null ? tsl('promo.unlimited_uses') : tsl('promo.max_uses', model)}</span>}
                                                secondary={
                                                  <span><i className="zmdi zmdi-accounts" />{' '}{model.filtered_bookings_count}{model.filtered_bookings_count != model.bookings_count ? <span> / {model.bookings_count}</span> : ''}</span>
                                                }
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <ListItemText className="br-break"
                                                secondary={<span><i className="zmdi zmdi-alarm" />{' '}{model.valid_from !== null ? moment(model.valid_from).format("YYYY-MM-DD") : '-'}</span>}
                                                primary={<span><i className="zmdi zmdi-timer-off" />{' '}{model.valid_until !== null ? moment(model.valid_until).format("YYYY-MM-DD") : '-'}</span>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <ListItemSecondaryAction>
                                      <IconButton onClick={this.handleDeleteCode(model)}>
                                        <DeleteIcon/>
                                      </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider light />
                            </div>
                            );
                        }, this)}

                    </List>

                    <Table className="">
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.state.total}
                                    rowsPerPage={this.state.rowsPerPage}
                                    rowsPerPageOptions={[this.state.rowsPerPage]}
                                    page={this.state.page-1}
                                    onChangePage={this.handleChangePage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </div>
        </Paper>
        {this.renderGroupsDialog()}
        {this.renderDeleteCodeConfirmation()}
        {this.renderAddCodeDialog()}

        <Button raised fab color="accent"
          className="jr-fab-btn text-white"
          style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
          onClick={this.handleOpenAddCodeDialog}
         >
          <AddIcon/>
        </Button>
      </div>
      );
  }
}

export default withValidatedInputs(PromoCodesList);


// WEBPACK FOOTER //
// ./app/used/promo-codes/routes/List.js